module.exports = __webpack_public_path__ + "img/icon-gift-oin-card.3366ced4.svg";